const useHttpServiceMixin = services => ({
  created () {
    Object.keys(services)
      .forEach(key => {
        this[`$${key}`] = services[key](this.$http)
      })
  }
})

/**
 * create a service builder
 * @param {Object} actions
 * @returns {Function}
 */
const makeServiceBuilder = actions => http => {
  return Object.keys(actions)
    .reduce((acc, key) => {
      acc[key] = (...args) => actions[key](http, ...args)
      return acc
    }, {})
}

export { useHttpServiceMixin, makeServiceBuilder }
